export default {
p122aab00: "M13.75 11.25H11.25V13.75H13.75V11.25Z",
p1897bf80: "M16.25 8.75H13.75V11.25H16.25V8.75Z",
p211c2c00: "M16.25 3.75H13.75V6.25H16.25V3.75Z",
p2186da80: "M6.25 13.75H3.75V16.25H6.25V13.75Z",
p222a3580: "M6.25 3.75H3.75V6.25H6.25V3.75Z",
p272f6400: "M11.25 3.75H8.75V6.25H11.25V3.75Z",
p3116fbf0: "M8.75 6.25H6.25V8.75H8.75V6.25Z",
p35f3d00: "M8.75 11.25H6.25V13.75H8.75V11.25Z",
p3a546200: "M16.25 13.75H13.75V16.25H16.25V13.75Z",
p3b305d80: "M11.25 13.75H8.75V16.25H11.25V13.75Z",
p3dc0a000: "M6.25 8.75H3.75V11.25H6.25V8.75Z",
p3e48500: "M13.75 6.25H11.25V8.75H13.75V6.25Z",
p5986d00: "M11.25 8.75H8.75V11.25H11.25V8.75Z",
}

